import { map } from 'es-toolkit/compat';

// Where the request to print a chit is originating from
export enum PrintChitSource {
  // Printing multiple chits from service at once.
  PRINT_MULTIPLE = 'PRINT_MULTIPLE',
  // Manual print buttons
  MANUAL = 'MANUAL',
  // Any automatic action which requires chits to print (seating, new orders, etc.)
  AUTOMATIC = 'AUTOMATIC',
}

// This list can also be found at dashboard-ios/TockDashboard/src/Epson/ePOS2.h but with underscores.
export const EpsonPrinterSeries: string[] = [
  'TM-H6000',
  'TM-L90',
  'TM-M10',
  'TM-M30',
  'TM-M50',
  'TM-M50II',
  'TM-P20',
  'TM-P60',
  'TM-P60II',
  'TM-P80',
  'TM-T100',
  'TM-T20',
  'TM-T60',
  'TM-T70',
  'TM-T81',
  'TM-T82',
  'TM-T83',
  'TM-T83III',
  'TM-T88',
  'TM-T90',
  'TM-T90KP',
  'TM-U220',
  'TM-U330',
];

export const EpsonPrinterSeriesOptions: SelectOption[] = map(EpsonPrinterSeries, (name) => ({
  key: name,
  label: name,
  value: name,
}));

// This list can also be found at dashboard-ios/TockDashboard/src/StarMicronics//ModelCapability.swift.
const StarPrinterSeries: { [key: string]: string } = {
  FVP10: 'FVP10 (STR_T-001)',
  TSP100: 'TSP143',
  TSP650II: 'TSP654II (STR_T-001)',
  TSP700II: 'TSP743II (STR_T-001)',
  TSP800II: 'TSP847II (STR_T-001)',
  'mC-Print2': 'MCP21',
  'mC-Print3': 'MCP31',
  mPOP: 'POP10',
};

export const StarPrinterSeriesOptions: SelectOption[] = map(
  Object.keys(StarPrinterSeries),
  (key) => ({
    key,
    label: key,
    value: StarPrinterSeries[key],
  })
);
